import React from 'react'

import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'

interface TooltipIconButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: JSX.Element
  tooltip: string
  disabled?: boolean
  color?: 'primary' | 'secondary' | 'error'
  isToggled?: boolean
}

const TooltipIconButton = (props: TooltipIconButtonProps): JSX.Element => {
  const children = (
    <Button
      sx={{ borderRadius: '50%', minWidth: 'auto', width: '36px' }}
      color={props.color}
      disabled={props.disabled}
      aria-label={props.tooltip}
      variant={props.isToggled ? 'contained' : undefined}
      onClick={props.onClick}
    >
      {props.icon}
    </Button>
  )

  return props.disabled ? children : <Tooltip title={props.tooltip}>{children}</Tooltip>
}

export default TooltipIconButton
